module.exports = __webpack_public_path__ + "static/media/key.e2427803.svg";